var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex justify-between infoStyle" },
    [
      _c("div", { staticClass: "talent-info" }, [
        _c(
          "div",
          { staticClass: "talent-avatar" },
          [
            _c("el-avatar", {
              attrs: { size: 140, src: _vm.talentData.scholarVO?.avatar },
              on: { error: _vm.errorHandler },
            }),
            _vm.talentData.achievementUpdateVisible
              ? _c(
                  "div",
                  {
                    staticClass: "no-wrap avatar-btn-style pointer",
                    on: { click: _vm.syncGoogleData },
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-refresh",
                      staticStyle: { "margin-right": "6px" },
                    }),
                    _vm._v(
                      "成果更新:" +
                        _vm._s(_vm.talentData.lastUpdateTime || "-") +
                        " "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "text-left", staticStyle: { "margin-top": "8px" } },
          [
            _c(
              "div",
              { staticClass: "flex items-center flex-wrap" },
              [
                _c("div", { staticClass: "talent-name" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.talentData.scholarVO?.scholarName || "-") +
                      " "
                  ),
                ]),
                _vm._l(
                  _vm.talentData.scholarVO?.honors,
                  function (title, index) {
                    return _c("div", { key: index }, [
                      _c("div", { staticClass: "title-bg" }, [
                        _vm._v(_vm._s(title)),
                      ]),
                    ])
                  }
                ),
              ],
              2
            ),
            _c(
              "div",
              {
                staticClass: "org-style",
                style: {
                  color: _vm.talentData.scholarVO?.orgId ? "#1241C9" : "",
                },
              },
              [_vm._v(" " + _vm._s(_vm.talentData.scholarVO?.scholarOrg) + " ")]
            ),
            _vm.talentData.scholarVO?.nativePlace
              ? _c("div", { staticClass: "infoLine" }, [
                  _c("span", [_vm._v("籍贯：")]),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.talentData.scholarVO?.nativePlace || "-")
                    ),
                  ]),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "infoLine flex-wrap" },
              [
                _c("span", [_vm._v("研究领域：")]),
                _vm._l(
                  _vm.talentData.scholarVO?.fields,
                  function (field, index) {
                    return _c("p", { key: index }, [
                      _vm._v(" " + _vm._s(field.name) + "; "),
                    ])
                  }
                ),
              ],
              2
            ),
            _c("div", { staticClass: "infoLine" }, [
              _c("span", [_vm._v("联系电话：")]),
              _vm._v(_vm._s(_vm.talentData.scholarVO?.phone || "-") + " "),
            ]),
            _c("div", { staticClass: "infoLine email-space" }, [
              _c("span", [_vm._v("邮箱：")]),
              _c("span", [
                _vm._v(_vm._s(_vm.talentData.scholarVO?.email || "-")),
              ]),
            ]),
            _c("div", { staticClass: "infoLine" }, [
              _c("span", { staticClass: "flex items-center" }, [
                _vm._v("个人主页："),
              ]),
              _c(
                "div",
                {
                  staticClass: "pointer flex justify-center items-center",
                  staticStyle: {
                    width: "24px",
                    height: "24px",
                    "border-radius": "50%",
                    "background-color": "#1241C9",
                  },
                  style: {
                    backgroundColor: _vm.talentData.personalUrl
                      ? "#1241C9"
                      : "#999999",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.goInfoUrl(_vm.talentData.personalUrl)
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      width: "14px",
                      height: "14px",
                      src: require("@/assets/images/talent/boshi.png"),
                      alt: "",
                    },
                  }),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "flex justify-center items-center pointer",
                  staticStyle: {
                    width: "24px",
                    height: "24px",
                    "border-radius": "50%",
                    "margin-left": "10px",
                  },
                  style: {
                    backgroundColor: _vm.talentData.googleAddress
                      ? "#1241C9"
                      : "#999999",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.goInfoUrl(_vm.talentData.googleAddress)
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      width: "14px",
                      height: "14px",
                      src: require("@/assets/images/talent/google.png"),
                      alt: "",
                    },
                  }),
                ]
              ),
            ]),
          ]
        ),
      ]),
      _c("div", { staticStyle: { width: "350px" } }, [
        _c("div", { staticClass: "flex justify-end" }, [
          _vm.talentData.scholarReportVisible
            ? _c(
                "div",
                {
                  staticClass: "load-button",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.getReport(
                        "scholar",
                        _vm.talentData.scholarVO.scholarId,
                        _vm.talentData.scholarVO.scholarName
                      )
                    },
                  },
                },
                [_vm._v(" 人才报告 ")]
              )
            : _vm._e(),
          _vm.talentData.citationReportVisible
            ? _c(
                "div",
                {
                  staticClass: "load-button",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.getReport(
                        "citation",
                        _vm.talentData.scholarVO.googleId,
                        _vm.talentData.scholarVO.scholarName
                      )
                    },
                  },
                },
                [_vm._v(" 引文报告 ")]
              )
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "flex", staticStyle: { "margin-top": "40px" } },
          [
            _c(
              "div",
              {
                staticClass: "flex justify-center items-center achBorder",
                staticStyle: { "margin-right": "30px" },
              },
              [
                _c("div", { staticClass: "num-style" }, [
                  _c("span", [_vm._v("成果数")]),
                  _c(
                    "p",
                    {
                      staticClass: "blueColor",
                      staticStyle: { "margin-top": "5px" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.talentData.scholarVO?.achievementNum || "0"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "flex justify-center items-center hIndexBorder",
                staticStyle: { "margin-right": "30px" },
              },
              [
                _c("div", { staticClass: "num-style" }, [
                  _c("span", [_vm._v("H指数")]),
                  _c(
                    "p",
                    {
                      staticClass: "blueColor",
                      staticStyle: { "margin-top": "5px" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.talentData.scholarVO?.hindex || "0") +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "flex justify-center items-center backBorder" },
              [
                _c("div", { staticClass: "num-style" }, [
                  _c("span", [_vm._v("引用数")]),
                  _c(
                    "p",
                    {
                      staticClass: "blueColor",
                      staticStyle: { "margin-top": "5px" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.talentData.scholarVO?.citeNum || "0") +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        ),
      ]),
      _c("paymentDialog", {
        ref: "detailScholarReportPayment",
        attrs: { payType: "人才报告" },
      }),
      _c("paymentDialog", {
        ref: "detailCiteReportPayment",
        attrs: { payType: "引文报告" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }